export default "__VITE_ASSET__6vYmqr0I__"